var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataQuery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.109 8.445a3.068 3.068 0 10-.479 4.73l1.636 1.636a.614.614 0 10.868-.867l-1.637-1.637c.8-1.22.629-2.835-.409-3.862h.02zm-.868 3.474a1.84 1.84 0 11.536-1.305c.002.487-.19.956-.536 1.3v.005zm5.69.536a.614.614 0 00.614-.614V3.455a.818.818 0 00-.818-.819h-2.454v-.818A.818.818 0 0013.455 1H6.909a.818.818 0 00-.818.818v.818H3.636a.818.818 0 00-.818.819v14.727c0 .452.366.818.818.818h13.091a.818.818 0 00.818-.818v-2.66a.614.614 0 00-1.227 0v2.25H4.045V3.865h2.046v.818c0 .452.366.818.818.818h6.546a.818.818 0 00.818-.818v-.818h2.045v7.977c0 .339.275.614.614.614zm-3.886-8.182H7.318V2.227h5.727v2.046z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataQuery);
export default __webpack_public_path__ + "static/assets/dataQuery.b029c646.svg";
export { ForwardRef as ReactComponent };